import { useQuery } from 'react-query';
import { notificationApi } from '../services/api';
import { AttentionSummary } from '../types/notification';

export const ATTENTION_SUMMARY_QUERY_KEY = 'attentionSummary';

export const useAttentionSummary = (companyId?: number) =>
  useQuery<AttentionSummary>(
    [ATTENTION_SUMMARY_QUERY_KEY, companyId],
    () => notificationApi.getSummary(),
    {
      enabled: !!companyId,
      refetchInterval: 60_000,
      staleTime: 30_000,
    }
  );
